import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash'
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Modal from '@mui/material/Modal';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import DateRangeEdit from './DateRangeEdit';

import { sub } from 'date-fns'
import { zhTW } from "date-fns/locale";

import ModalHeader from '../pop/ModalHeader';
import ModalFooter from '../pop/ModalFooter';

import theme from '../../theme';

import useColorSystem from '../../hook/useColorSystem';
import useGlobalStatus from '../../hook/useGlobalStatus';

import { DateRangeOutlinedIcon, SettingsOutlinedIcon, DescriptionOutlinedIcon } from '../../constants/images';

import { BoxModalWrapper, BoxBorderGrey } from '../customComponent';

import { parseDate } from '../../utils/date';


const DownloadReportModal = (props) => {
  const {
    media,
    open,
    reportDateRange,
    setReportDateRange,
    inputErrorMsg,
    isLoading,
    handleClose,
    handleChooseSaveReport,
    campaignGoalsList,
    campaignGoalsSelected,
    setCurrentSheetName,
    setCurrentSheetOrigiName,
  } = props;

  const { currentActiveData, locale, entryPath, modalContent, modalData, setModalData } = useGlobalStatus();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();
  const [saveSettings, setSaveSettings] = useState('saveReport');

  useEffect(() => {
    if (entryPath.includes("edit")) {
      const getDate = (date) => date ? parseDate(date) : null;
      setReportDateRange({
        startReportDate: getDate(currentActiveData.startReportDate),
        endReportDate: getDate(currentActiveData.endReportDate)
      })
    }
  }, [entryPath, currentActiveData])

  const changeSaveSettings = (e) => {
    const { value } = e.target;
    setSaveSettings(value);
  }

  return (
    <>
      {
        <Modal
          open={open}
          onClose={handleClose}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <BoxModalWrapper
            sx={{
              width: '45%'
            }}
          >
            <ModalHeader
              title={<FormattedMessage id="common.button.downloadReport" />}
              handleClose={handleClose}
            />
            <Box
              sx={{
                alignItems: 'center',
                width: '100%',
                padding: '30px 40px 50px'
              }}
            >
              <DateRangeEdit
                dateRange={reportDateRange}
                setDateRange={setReportDateRange}
                inputErrorMsg={inputErrorMsg}
              />

              {/* 報表儲存設定 */}
              <Box mt={5}>
                <Box>
                  <Typography
                    sx={{
                      ...theme.typography.h4_normal,
                      mb: 2,
                      color: theme.palette.grey.w700,
                      display: "flex",
                      alignItems: 'center'
                    }}
                  >
                    <SettingsOutlinedIcon
                      sx={{
                        mr: 0.5,
                        verticalAlign: 'sub'
                      }}
                    />
                    <FormattedMessage id="createData.modal.download.chooseSaveReport" />
                  </Typography>
                </Box>
                <Box>
                  <RadioGroup
                    value={saveSettings}
                    onChange={changeSaveSettings}
                  >
                    <FormControlLabel
                      value="saveReport"
                      control={<Radio />}
                      label={<FormattedMessage id="createData.modal.download.saveSettings" />}
                    />

                    <FormControlLabel
                      value="doNotSave"
                      control={<Radio />}
                      label={<FormattedMessage id="createData.modal.download.withoutSaving" />}
                    />
                  </RadioGroup>
                </Box>
              </Box>
              {/* LINE下載廣告目標報表 */}
              {
                media === 'LINE' &&
                <Box mt={5}>
                  <Box>
                    <Typography
                      sx={{
                        ...theme.typography.h4_normal,
                        mb: 2,
                        color: theme.palette.grey.w700,
                        display: "flex",
                        alignItems: 'center'
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{
                          mr: 0.5,
                          verticalAlign: 'sub'
                        }}
                      />
                      下載廣告目標報表
                    </Typography>
                  </Box>

                  <Box>
                    {
                      campaignGoalsList
                        .filter((item) => _.findIndex(campaignGoalsSelected, c => c === item.campaignGoalEng) > -1)
                        .map((el, index) => {
                          return (
                            <BoxBorderGrey
                              key={el.campaignGoalEng}
                              sx={{
                                display: 'block',
                                width: {
                                  sm: '100%',
                                  md: '100%',
                                  lg: '50%'
                                },
                                border: '0px',
                                borderBottom: `1px solid ${theme.palette.grey.w300}`,
                                ml: 2,
                                p: 1
                              }}>
                              <List component="div" disablePadding>
                                <ListItem
                                  sx={{
                                    width: 'auto',
                                    padding: 0,
                                  }}
                                >
                                  <ListItemText id={el.campaignGoalEng} primary={el.campaignGoalName} sx={{ margin: 0 }}></ListItemText>
                                  <Button
                                    variant="contained"
                                    color={colorMedia}
                                    onClick={(e) => {
                                      setCurrentSheetName(el.campaignGoalName);
                                      setCurrentSheetOrigiName(el.campaignGoalEng);
                                      handleChooseSaveReport(saveSettings);
                                    }}
                                  >
                                    下載
                                  </Button>
                                </ListItem>
                              </List>
                            </BoxBorderGrey>
                          )
                        })
                    }
                  </Box>
                </Box>
              }
            </Box>
            {
              media === 'LINE' ? (
                <ModalFooter
                  type='cancel'
                  handelCancel={handleClose}
                />
              ) : (
                <ModalFooter
                  processing={isLoading}
                  handelCancel={handleClose}
                  handleSubmit={() => handleChooseSaveReport(saveSettings)}
                />
              )
            }
          </BoxModalWrapper>
        </Modal>
      }
    </>
  )
}

export default DownloadReportModal;